<template>
    <div>
        <div class="card-body" >
            <table class="table" v-loading=" $parentInfo.limitDetail.loading">
                <thead>
                <tr>
                    <th>学生</th>
                    <th>时间</th>
                    <th>合同总额</th>
                    <th>使用额度</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in $parentInfo.limitDetail.headTeacherLimits_bills">
                    <td>{{item.name}}</td>
                    <td>{{item.created_at}}</td>
                    <td>{{item.invoice_payment}}</td>
                    <td>{{item.balance}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "students-list",
        data() {
            return {
                loading: 'true',
            }
        },
        computed: {
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleTeacherLimitDetail();
        },
        methods: {
            handleTeacherLimitDetail() {
                this.$wApi.send(this.$parentInfo.path, 'get_detail', {
                    'headTeacherLimit_id': this.$store.state.modal.data.headTeacherLimit_id,
                });
            },
        }
    }
</script>

<style scoped>

</style>